export default __webpack_public_path__ + "static/media/stamp.633a8302.svg";